import { FORM_ERROR } from 'final-form'

export const formatFormServerError = error => ({
  [FORM_ERROR]: error.message,
  ...error.errors,
})
